import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useIsMobile from "../../utils/isMobile";

const AITechnology = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [tabValue, setTabValue] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section class="contents">
      <div class="ai-technology">
        <div class="top3">
          <div class="inner">
            <h1 data-aos="fade-up">{t("technology.top.header")}</h1>
            <p class="txt1" data-aos="fade-up">
              {t("technology.top.p")}
            </p>
            <div class="list">
              <div class="item" data-aos="fade-up">
                <dl>
                  <dt>{t("technology.top.item1.dt")}</dt>
                  <dd>{t("technology.top.item1.dd")}</dd>
                </dl>
              </div>
              <div class="item" data-aos="fade-up">
                <dl>
                  <dt>{t("technology.top.item2.dt")}</dt>
                  <dd>{t("technology.top.item2.dd")}</dd>
                </dl>
              </div>
            </div>
            <p class="txt2" data-aos="fade-up">
              {t("technology.top.txt.1")}
              <br />
              <strong>{t("technology.top.txt.2")}</strong>
            </p>
          </div>
        </div>

        <div class="tab-contents">
          <div class="tab-menu">
            <ul>
              <li>
                <a
                  href="javascript:;"
                  class={tabValue === 0 ? "active" : ""}
                  onClick={() => setTabValue(0)}
                >
                  <span>{t("technology.top.tab.title.1")}</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  class={tabValue === 1 ? "active" : ""}
                  onClick={() => setTabValue(1)}
                >
                  <span>{t("technology.top.tab.title.2")}</span>
                </a>
              </li>
            </ul>
          </div>

          <div
            class="tab-content tab-targeting1"
            style={
              isMobile
                ? { display: "block" }
                : tabValue === 0
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <div class="tit">
              <h2>{t("technology.top.tab.content.1.header")}</h2>
              <p>{t("technology.top.tab.content.1.p")}</p>
            </div>
            <div class="img"></div>
            <div class="txt">
              <h3>{t("technology.top.tab.content.1.txt.header")}</h3>
              <div class="bg-dot">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p>{t("technology.top.tab.content.1.txt.p1")}</p>
              <p>
                <strong>{t("technology.top.tab.content.1.txt.p2")}</strong>
              </p>
            </div>
            <div class="list">
              <div class="item">
                <dl>
                  <dt>{t("technology.top.tab.content.1.item1.dt")}</dt>
                  <dd>{t("technology.top.tab.content.1.item1.dd")}</dd>
                </dl>
              </div>
              <div class="item">
                <dl>
                  <dt>{t("technology.top.tab.content.1.item2.dt")}</dt>
                  <dd>{t("technology.top.tab.content.1.item2.dd")}</dd>
                </dl>
              </div>
              <div class="item">
                <dl>
                  <dt>{t("technology.top.tab.content.1.item3.dt")}</dt>
                  <dd>{t("technology.top.tab.content.1.item3.dd")}</dd>
                </dl>
              </div>
            </div>
          </div>

          <div
            class="tab-content tab-targeting2"
            style={
              isMobile
                ? { display: "block" }
                : tabValue === 1
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <div class="tit">
              <h2>{t("technology.top.tab.content.2.header")}</h2>
              <p>{t("technology.top.tab.content.2.p")}</p>
            </div>
            <div class="img"></div>
            <div class="txt">
              <h3>{t("technology.top.tab.content.2.txt.header")}</h3>
              <div class="bg-dot">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p>
                {t("technology.top.tab.content.2.txt.p1")}
                <br />
                {t("technology.top.tab.content.2.txt.p2")}
                <br />
                {t("technology.top.tab.content.2.txt.p3")}
              </p>
              <p>
                <strong>{t("technology.top.tab.content.2.txt.p4")}</strong>
              </p>
            </div>
            <div class="list">
              <div class="item">
                <dl>
                  <dt>{t("technology.top.tab.content.2.item1.dt")}</dt>
                  <dd>{t("technology.top.tab.content.2.item1.dd")}</dd>
                </dl>
              </div>
              <div class="item">
                <dl>
                  <dt>{t("technology.top.tab.content.2.item2.dt")}</dt>
                  <dd>{t("technology.top.tab.content.2.item2.dd")}</dd>
                </dl>
              </div>
              <div class="item">
                <dl>
                  <dt>{t("technology.top.tab.content.2.item3.dt")}</dt>
                  <dd>{t("technology.top.tab.content.2.item3.dd")}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AITechnology;
